import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { PresentationImage } from 'widgets/PresentationMode/ui/content/image/PresentationImage'
import { PresentationVideo } from 'widgets/PresentationMode/ui/content/video/PresentationVideo'
import { PresentationAudio } from 'widgets/PresentationMode/ui/content/audio/PresentationAudio'
import { PresentationDoc } from 'widgets/PresentationMode/ui/content/doc/PresentationDoc'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import { PresentationPdf } from 'widgets/PresentationMode/ui/content/pdf/PresentationPdf'

export const PresentationContent = observer(() => {
  const presentationStore = usePresentationModeContext()
  const { currentAttachment } = presentationStore
  return useMemo(() => {
    if (
      currentAttachment?.type === 'image' ||
      currentAttachment?.type === 'gif' ||
      currentAttachment?.type === 'previewGif'
    ) {
      return <PresentationImage />
    }
    if (currentAttachment?.type === 'video') {
      return <PresentationVideo />
    }
    if (currentAttachment?.type === 'audio') {
      return <PresentationAudio />
    }
    if (currentAttachment?.type === 'pdf') {
      return <PresentationPdf />
    }

    return <PresentationDoc />
  }, [currentAttachment])
})
